// extracted by mini-css-extract-plugin
export default {"bottom":"Bottom_bottom__5pAKn","stackOnDesktop":"Bottom_stackOnDesktop__YyOdt","floating":"Bottom_floating__5f3d9","placeholderForFloater":"Bottom_placeholderForFloater__ZARup"};